import React, { useState, useEffect } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types";
import { generatePath, useNavigate } from "react-router-dom";
import { displayDateTimeSeconds } from "../../../../utils/displayTime";
import { createMarkup } from "../../../../utils/common";
import { BASE_URL } from "../../../../apis/apiConstants";
import { useI18n } from "../../../../i18n/useI18n";
import { routeURLs } from "../../../../utils/enums";

const [HbrCard, HbrButton, HbrBadge] = reactWrapper(["hbr-card", "hbr-button", "hbr-badge"]);

const InsightsMessage = (props) => {
  const { tViews } = useI18n('views');
  const [showMoreDetailLink, setshowMoreDetailLink] = useState(false);
  const onClickOpen = (notificationMsg) => {
    props.modalAction(notificationMsg);
    props.refNotificationInsightModal.current.element.show();
  }
  const navigate = useNavigate();
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash; // Get the current hash
      if (!hash.includes("deeplink")) return;
      const myArray = hash.split("deeplink");
      if (myArray[0] === "#/") {
        const urlParams = new URLSearchParams(myArray[1]);
        //site id set in site dropdown
        const siteId = urlParams.get('site');
        if (siteId !== null) {
          props.setSelectedSite(siteId);
        }

        // redirect to overview page
        if (urlParams.size === 2 && !urlParams.has('tab')) {
          navigate(routeURLs.overview);
        }

        // only site id send from response
        if (urlParams.size === 2 && siteId !== null) {
          navigate(routeURLs.overview);
        }

        // Insights link redirect to tab
        const tabName = urlParams.get('tab');
        if (tabName !== null) {
          let path = ["anomalydetection", "bandwidthforecasting"].includes(tabName) ?
            `${BASE_URL}/predictivenetworks/${tabName}` :
            `${BASE_URL}/${tabName}`;
          navigate(path);
        }

        // Insights link redirect to app360
        const applicationName = urlParams.get('application');
        if (applicationName !== null) {
          const path = generatePath(routeURLs.app360, { appName: applicationName });
          navigate(path);
        }

        // Insights link redirect to circuit 360
        /********set circuit name redirect to circuit 360 url */
        const device_id = urlParams.get('device_id');
        const local_color = urlParams.get('color');
        const device_host_name = urlParams.get('device_host_name');
        const bandwidth_downstream = urlParams.get('bandwidth_downstream');
        const bandwidth_upstream = urlParams.get('bandwidth_upstream');

        if (device_host_name !== null) {
          let circuitNameRedirect = device_host_name + "~" + local_color;
          let circuitDisName = device_host_name + ":" + local_color;
          let circuitName = device_id + ":" + local_color;
          const circuit = {
            vdevice_id: device_id,
            color: local_color,
            device_host_name: device_host_name,
            circuit_display_name: circuitDisName,
            circuit_name: circuitName,
            bandwidth_downstream: bandwidth_downstream,
            bandwidth_upstream: bandwidth_upstream,
            site_id: parseInt(siteId)
          }
          sessionStorage.setItem(
            "circuit",
            JSON.stringify({
              ...circuit,
              overlay: localStorage.getItem("currentOverlay")
            })
          );

          const path = generatePath(routeURLs.circuit360, { circuitName: circuitNameRedirect });
          navigate(path);
        }
      }
    };

    // Listen for hash changes
    window.addEventListener("hashchange", handleHashChange);

    // Handle initial load
    handleHashChange();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (props.isAccordianOpen) {
      setTimeout(() => {
        const element = document.getElementById(`content-description-${props.indexValue}`);
        // check content height is exceeds scroll height to show the read more link
        const isTextEllipsisApplied = (el) => {
          if (!el) return false; // Ensure the element exists
          return el.scrollHeight > el.clientHeight; // Check if the content is overflowing
        }
        // to check ellipsis in content or not
        if (isTextEllipsisApplied(element)) {
          setshowMoreDetailLink(true);
        } else {
          setshowMoreDetailLink(false);
        }
      }, 1000);
    }
  }, [props.isAccordianOpen])

  return (
    <HbrCard className="insights-message-card-main">
      <div>
        <div slot="header" className="insights-card-header" >
          <div className="main-header title-badge">
            <div className="hbr-type-h3">
              <HbrBadge pill size="small">
                {props.notificationMessage.title}
              </HbrBadge>
            </div>
          </div>
          <div data-cy="timeFilterDropDown" className="title-timestamp">
            {displayDateTimeSeconds(props.notificationMessage.created_at)}
          </div>
        </div>

        <div className="insights-card-content">

          <div id={`content-description-${props.indexValue}`} className="content-description" dangerouslySetInnerHTML={createMarkup(props.notificationMessage.message)}></div>
          {showMoreDetailLink &&
            <div className="content-redmore">
              <HbrButton variant="text" onClick={() => onClickOpen(props.notificationMessage)} >
                {tViews('notificationMoreDetails')}
              </HbrButton>
            </div>
          }
        </div>
      </div>
    </HbrCard>
  )
}

InsightsMessage.propTypes = {
  refNotificationInsightModal: PropTypes.object,
  modalAction: PropTypes.func,
  indexValue: PropTypes.any,
  setSelectedSite: PropTypes.func,
  setCtrlTimeFilter: PropTypes.func,
  notificationMessage: PropTypes.any,
  isAccordianOpen: PropTypes.any
}
export default InsightsMessage;
